<script lang="ts">
	import { Button, ButtonSize, ButtonType } from '@repo/commons/components'

	interface Props {
		src: string
		alt?: string
		onOpenModal?: ((src: string) => void) | null
	}

	let { src = '', alt = 'Chat image', onOpenModal = null }: Props = $props()

	const handleOpenModal = () => {
		onOpenModal?.(src)
	}
</script>

<div class="chat-image-container">
	<img {src} {alt} class="chat-image" />
	{#if onOpenModal}
		<div class="ex-button">
			<Button
				buttonType={ButtonType.TERTIARY_INVERSE}
				buttonSize={ButtonSize.MEDIUM}
				rounded
				iconProps={{ name: 'fullScreen', size: 'lg', class: 'text-[#000000]' }}
				onclick={handleOpenModal}
			/>
		</div>
	{/if}
</div>

<style>
	.chat-image-container {
		@apply relative block w-full max-w-sm my-3;
	}

	.chat-image {
		@apply rounded-lg border border-solid shadow-md w-full h-auto block;
		@apply max-h-[400px] object-contain;
		border-color: #dcdfe6;
	}

	.ex-button {
		@apply absolute z-10 flex items-center justify-center cursor-pointer;
		@apply bg-white/70 hover:bg-gray-200 rounded-lg p-2 shadow-lg;
		@apply w-[47px] h-[47px] transition-colors duration-300 ease-in-out;
		top: 4%;
		right: 4%;
	}

	.ex-button :global(.button-class .inner-container) {
		height: 45px;
	}
</style>
